import CarouselCard from './CarouselCard';

export default CarouselCard;
